export const UPLOAD_STATE_PENDING = 'pending';
export const UPLOAD_STATE_UPLOADING = 'uploading';
export const UPLOAD_STATE_UPLOADED = 'uploaded';
export const UPLOAD_STATE_CANCELED = 'canceled';

export const UPLOAD_MAX_RETRIES = 2;
